import React, { useState } from "react";
import { toast } from "react-toastify";
import { connect, useDispatch, useSelector } from "react-redux";

import Button from "../../components/Button";
import Input from "../../components/Input";

import * as client from "../../services/client";

import { fetchMainServiceRequestPDFDownloadList } from "../../store/actions/csvExport";

//Created By: Anjali
//Created On: 12-07-2023
//Jira-Id: https://bosframework.atlassian.net/browse/JUN-3937
//Reason: Allow for changing the name of the file that is rendered in the UI, Include the ability to delete a given PDF download

const EditPDFFileName = ({
  pdfdata,

  handlepopup,
}) => {
  const [pdfName, setPdfName] = useState(pdfdata.fileName);
  const [isShowPopUp, setIsShowPopUp] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);
  const [disableButton, setDisable] = useState(false);

  //State data
  const auth = useSelector((state) => state.auth);
  const userID = auth && auth.user && auth.user.id;

  const handlefilename = (e) => {
    setPdfName(e.target.value);
  };
  const close = () => {
    setIsShowPopUp(false);
    handlepopup(false);
  };

  const dispatch = useDispatch();

  //Update PDF name
  const handleSubmit = async (e) => {
    if (pdfName !== null && pdfName.length <= 50 && pdfName.length != 0) {
      setErrorMessage("");
      let validFileNameRegex = /^(?! )[a-zA-Z0-9, _@-]*$/
      
      try {
        if (validFileNameRegex.test(pdfName)) {
        const userDetails = JSON.parse(localStorage.getItem("user"));
        const response = await client.UpdateUserPDFName(
          userDetails.id,
          pdfdata.id,
          pdfName
        );
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            if (responsejson.statusCode === 200) {
              close();
              dispatch(fetchMainServiceRequestPDFDownloadList(userID));
              if (responsejson.message) {
                toast.success(responsejson.message, {
                  autoClose: 10000,
                  position: "top-center",
                });
              }
            } else {
              close();
              if (responsejson.message) {
                toast.error(responsejson.message, {
                  autoClose: 5000,
                  position: "top-center",
                });
              }
            }
          });
        } else {
          // setIsShowPopUp(false);
          close()
        }
      }
      else {
        setErrorMessage("Please use only letters, numbers, and the following characters: @ - _")
      }
      } catch {}
    } 
    else {
      if (pdfName === null) {
        setErrorMessage("Please enter file name.");
      } else {
        setErrorMessage("File name must be 50 characters or less.");
      }
    }
  };

  return (
    <>
      {isShowPopUp ? (
        <div className="modalContainer" >
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <header className="modal_header">
              <h2 className="modal_header-title" style={{ textAlign: "left" }}>
              PDF Export Name
              </h2>
              <div className="filters_modal_close_icon" onClick={() => close()}>
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z"
                    fill="black"
                  />
                </svg>
              </div>
            </header>
            <main className="modal_content">
              <Input
                value={pdfName}
                label="File Name"
                onChange={(e) => handlefilename(e)}
                placeholder="File Name"
                block
                errors={errorMessage}
              />
            </main>
            <footer className="modal_footer">
              <Button
                color="teal"
                size="small"
                onClick={() => {
                  handleSubmit();
                }}
                label="Submit"
                disabled={pdfName?.length===0}
              ></Button>
            </footer>
          </div>
        </div>
      ) : null}
    </>
  );
};
const mapStateToProps = (state) => ({
  userId: state,
});
export default connect(mapStateToProps)(EditPDFFileName);